import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractSpecificationVisitor from "./AbstractSpecificationVisitor.js";

/**
 * `AbstractTextRepresentationSpecificationVisitor` is used to display
 * specifications in text form. It is an abstract class this is subclassed
 * for a given specification type.
 *
 * @abstract
 */
export default class AbstractTextRepresentationSpecificationVisitor extends AbstractSpecificationVisitor {
	visitOrSpecification(aSpecification) {
		return aSpecification
			.getSpecifications()
			.map((spec) =>
				spec.isAnd() ? `(${this.visit(spec)})` : this.visit(spec),
			)
			.join(", ");
	}

	visitAndSpecification(aSpecification) {
		return aSpecification
			.getSpecifications()
			.map((spec) =>
				spec.isOr() ? `(${this.visit(spec)})` : this.visit(spec),
			)
			.join(" & ");
	}

	visitNotSpecification(aSpecification) {
		const negatedSpecification = aSpecification.getSpecification();
		if (negatedSpecification.isLeaf()) {
			return _("not {spec}", { spec: this.visit(negatedSpecification) });
		}
		return _("not ({spec})", { spec: this.visit(negatedSpecification) });
	}
}
